import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import UIButton from 'UIComponents/button/UIButton';
import { ErrorKey } from '../app-active-error/ErrorKey';
import StandardError from '../app-active-error/StandardError';
import imageUrls from '../images/imageUrls';
import { useRecaptchaChallenge } from './hooks/useRecaptchaChallenge';
import { RecaptchaCheckbox } from './RecaptchaCheckbox';
import { SignupEmbedder } from 'signup-embedder';

const RecaptchaCreationErrorView = () => {
  const errorKey = ErrorKey.RecaptchaCreationError;
  const {
    isChallengeResolved,
    onErrorHandler,
    onExpiredHandler,
    onClick,
    onResolvedHandler
  } = useRecaptchaChallenge();
  const isEmbedded = SignupEmbedder.isActive();
  const recaptchaPosition = isEmbedded ? 'left' : 'center';

  const renderContent = () => {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(RecaptchaCheckbox, {
        className: `display-flex justify-${recaptchaPosition} m-bottom-10 m-top-10`,
        isEmbedded: isEmbedded,
        onError: onErrorHandler,
        onExpired: onExpiredHandler,
        onResolved: onResolvedHandler
      }), /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-selenium": "retrySignup",
          disabled: !isChallengeResolved,
          use: "primary",
          onClick: onClick,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: `error.${errorKey}.retryButtonText`
          })
        })
      })]
    });
  };

  return /*#__PURE__*/_jsx(StandardError, {
    errorKey: errorKey,
    imageURL: imageUrls.recaptchaVerification,
    renderContent: renderContent
  });
};

export default RecaptchaCreationErrorView;